import type { GetEducationFeaturesResponse } from '../types';

export const parseEducationFeatures = (
    data: GetEducationFeaturesResponse | undefined,
    institutionId?: number | null
): { enableQuizV2Api: boolean; enableOpenSearchForQuizLibrary: boolean } => {
    if (!data?.value?.features) {
        return { enableQuizV2Api: false, enableOpenSearchForQuizLibrary: false };
    }
    const { global, institutions } = data.value.features;

    const resolveFlag = (key: string): boolean => {
        if (institutionId != null) {
            const inst = institutions?.[String(institutionId)];
            if (inst && key in inst) return Boolean(inst[key]);
        }
        return global && key in global ? Boolean(global[key]) : false;
    };

    return {
        enableQuizV2Api: resolveFlag('enableQuizV2Api'),
        enableOpenSearchForQuizLibrary: resolveFlag('enableOpenSearchForQuizLibrary'),
    };
};
